// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__nFykE","additionalInfo":"AgreementModal_additionalInfo__1roSA"};